export function getRefLevelStats(user, level) {
    if (user.ref_stats.levels) {
        for (const levelData of user.ref_stats.levels) {
            if (parseInt(levelData.level) === parseInt(level)) {
                return levelData;
            }
        }
    }
    return null;
}